import { INSURANCE_TYPES } from '../../../../../../constants';
import { ONBOARDING_TAB_IDS } from '../../../constants';

export const INSURANCE_FORM_NAME_MIN_LENGTH = 2;
export const INSURANCE_FORM_TEXT_MIN_LENGTH = 4;
export const INSURANCE_FORM_LAST_NAME_MIN_LENGTH = 2;
export const INSURANCE_FORM_CITY_MIN_LENGTH = 2;
export const INSURANCE_FORM_ZIP_LENGTH = 5;
export const INSURANCE_FORM_PHONE_LENGTH = 10;

export const INSURANCE_TYPE_TAB_IDS = {
  [INSURANCE_TYPES.PRIMARY]: ONBOARDING_TAB_IDS.PRIMARY_INSURANCE,
  [INSURANCE_TYPES.SECONDARY]: ONBOARDING_TAB_IDS.SECONDARY_INSURANCE,
} as const;

export const INSURANCE_TYPE_TITLES = {
  [INSURANCE_TYPES.PRIMARY]: 'Primary Insurance',
  [INSURANCE_TYPES.SECONDARY]: 'Secondary Insurance',
} as const;

export const INSURANCE_DOCUMENT_SUB_TYPES = {
  PRIMARY_FRONT: 'PRIMARY_FRONT',
  PRIMARY_BACK: 'PRIMARY_BACK',
  SECONDARY_FRONT: 'SECONDARY_FRONT',
  SECONDARY_BACK: 'SECONDARY_BACK',
} as const;

export const INSURANCE_CARD_SIDES = {
  FRONT: 'front',
  BACK: 'back',
} as const;

export const INSURANCE_CARD_DOCUMENT_SUB_TYPES = {
  [INSURANCE_TYPES.PRIMARY]: {
    [INSURANCE_CARD_SIDES.FRONT]: INSURANCE_DOCUMENT_SUB_TYPES.PRIMARY_FRONT,
    [INSURANCE_CARD_SIDES.BACK]: INSURANCE_DOCUMENT_SUB_TYPES.PRIMARY_BACK,
  },
  [INSURANCE_TYPES.SECONDARY]: {
    [INSURANCE_CARD_SIDES.FRONT]: INSURANCE_DOCUMENT_SUB_TYPES.SECONDARY_FRONT,
    [INSURANCE_CARD_SIDES.BACK]: INSURANCE_DOCUMENT_SUB_TYPES.SECONDARY_BACK,
  },
} as const;

export const INSURANCE_DOCUMENT_DEFAULT_TITLES = {
  [INSURANCE_DOCUMENT_SUB_TYPES.PRIMARY_FRONT]: 'Ins Card primary front',
  [INSURANCE_DOCUMENT_SUB_TYPES.PRIMARY_BACK]: 'Ins Card primary back',
  [INSURANCE_DOCUMENT_SUB_TYPES.SECONDARY_FRONT]: 'Ins Card secondary front',
  [INSURANCE_DOCUMENT_SUB_TYPES.SECONDARY_BACK]: 'Ins Card secondary back',
} as const;

export const RELATIONSHIP_TO_POLICYHOLDER_OPTIONS = [
  { value: 'SELF', label: 'Self' },
  { value: 'SPOUSE', label: 'Spouse' },
  { value: 'CHILD', label: 'Child' },
  { value: 'OTHER', label: 'Other' },
] as const;

export const POLICYHOLDER_GENDER_OPTIONS = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
] as const;

